export const getParsedQueryString = (search) => search && search.slice(1).split('&').reduce((res, item) => {
  const [key, value] = item.split('=');
  res[key] = value;
  return res;
}, {});
